import React from 'react';
import { Route, Switch } from 'react-router-dom'
import ReactGA from 'react-ga';
import { connect } from 'react-redux';

// Usable modules
import Wrapper from './config/wrapper'
import { Auth } from '~/services'

import { Nav } from './components'
import { Article, Community, Discover, PasswordRequest, PasswordReset, Profile, Registration, Search, Verification, Workshop, Video, Signup, PageNotFound } from './views'


function requireAuth (nextState, replace) {
    if (!Auth.loggedIn()) {
        replace('/login?error=restricted_access')
    }
}

function logPathChange(e) {
    let path = e.location.pathname.slice(-1) === '/' ? e.location.pathname : e.location.pathname+'/';
    ReactGA.pageview(path);
}

function forwardIfLoggedOut(nextState, replace) {
    if( !Auth.loggedIn() ) {
        replace('/discover/')
    } else {
        logPathChange(nextState)
    }
}

const wrap = (_Component, props) => {
    /*return connect(
        state => ({
            ...state
        })
    )(_Component);*/
    return <Wrapper><_Component {...props} /></Wrapper>
}

export default () => {
    return (
        <Switch>

            <Route exact={true} path="/" render={wrap.bind({}, Discover)} onEnter={logPathChange} />

            <Route exact={true} path="/discover" render={wrap.bind({}, Discover)} onEnter={logPathChange} />
            <Route exact={true} path="/discover/:slug" render={wrap.bind({}, Discover)} onEnter={logPathChange} />
            <Route exact={true} path="/discover/:slug/:filter" render={wrap.bind({}, Discover)} onEnter={logPathChange} />
            <Route exact={true} path="/video/:slug" render={wrap.bind({}, Video)} onEnter={logPathChange} />

            <Route exact={true} path="/articles/:slug" render={wrap.bind({}, Article)} onEnter={logPathChange} />
            {/*<Route exact={true} path="/workshops/:slug" render={wrap.bind({}, Workshop)} onEnter={logPathChange} />*/}

            <Route exact={true} path="/member/:user_id" render={wrap.bind({}, Profile)} onEnter={logPathChange} />
            <Route exact={true} path="/sign-up" render={wrap.bind({}, Signup)} onEnter={logPathChange} />

            {/*<Route exact={true} path="/" component={wrap.bind({}, Community)} onEnter={forwardIfLoggedOut} />*/}

            {/*<Route exact={true} path="/verify/:key" component={wrap.bind({}, Verification)} />*/}
            {/*<Route exact={true} path="/password-reset" component={wrap.bind({}, PasswordRequest)} />*/}
            {/*<Route exact={true} path="/password-reset/:key" component={wrap.bind({}, PasswordReset)} />*/}

            {/*<Route exact={true} path="/register" component={wrap.bind({}, Registration)} onEnter={logPathChange} />*/}
            {/*<Route exact={true} path="/register/:stripe_customer_id" component={wrap.bind({}, Registration)} onEnter={logPathChange} />*/}
            {/*<Route exact={true} path="/login" component={wrap.bind({}, Registration)} onEnter={logPathChange} />*/}

            {/*<Route exact={true} path="/community" component={wrap.bind({}, Community)} onEnter={forwardIfLoggedOut} />*/}
            {/*<Route exact={true} path="/camp/:slug" component={wrap.bind({}, Community)} onEnter={forwardIfLoggedOut} />*/}

            {/*<Route exact={true} path="/search" component={wrap.bind({}, Search)} onEnter={forwardIfLoggedOut}  />*/}

            {/*<Route exact={true} path="/me" component={wrap.bind({}, Profile)} onEnter={forwardIfLoggedOut} />*/}

            {/*<Route exact={true} path="/member/:user_id" component={wrap.bind({}, Profile)} onEnter={logPathChange} />*/}

            <Route render={wrap.bind({}, PageNotFound)} onEnter={logPathChange} />

        </Switch>
    );
}


// WEBPACK FOOTER //
// ./src/js/App.js